import { useState } from 'react';
import { NoDataComponent } from '../../../adminComponents/NoDataComponent/NoDataComponent';
import { TooltipIcon } from '../../../adminComponents/Tooltips/Tooltips';
import { ModalPortal } from '../../../components/modal/modalPortal';
import {
  formatDateTimeFull,
  formatDateTimeShort,
  renderFleetImage,
  renderFleetName,
  renderFleetSource,
  renderQuoteHistoryError,
} from '../../../helpers';
import {
  Box,
  Disclaimer,
  Div,
  Img,
  lightTheme,
  P,
  Pill,
} from '../../../styles';
import {
  VDriveGetQuoteHistoryResponse,
  VDriveOffer,
  VDriveSource,
} from '../../../types/deliveries.types';
import { VDriveProvider } from '../../../types/shared.types';
import { QuoteOfferComponent } from './VDriveAssignDriver';

export const HistoryAssign = ({
  closeModal,
  historyAssignModal,
  chosenVDriveProvider,
  chosenVDriveSource,
}: {
  closeModal: () => void;
  historyAssignModal: VDriveGetQuoteHistoryResponse[] | null;
  chosenVDriveProvider: VDriveProvider | null;
  chosenVDriveSource: VDriveSource | null;
}) => {
  const history = historyAssignModal;
  const [historyItemQuote, setHistoryItemQuote] =
    useState<VDriveGetQuoteHistoryResponse | null>(null);

  return (
    <>
      <ModalPortal
        isOpen={!!historyAssignModal}
        closeModal={closeModal}
        logo={false}
        header="Fleet Assign History
"
        width="800px"
        textAlign="left"
      >
        {history && history.length > 0 && (
          <Div
            $height="32px"
            $heightSM="32px"
            $background={lightTheme.primary}
            $borderRadius="16px"
            $flex
            $alignCenter
            $p="0 24px"
            $mb="8"
            $gap="24px"
            $between
          >
            <Div $width="33%">
              <P $m="0" $color={lightTheme.white}>
                Provider
              </P>
            </Div>
            <Div $width="33%">
              <P $m="0" $color={lightTheme.white}>
                Source
              </P>
            </Div>
            <Div $width="33%">
              <P $m="0" $color={lightTheme.white}>
                Status
              </P>
            </Div>
          </Div>
        )}
        {history &&
          history.map((item) => (
            <>
              <Div
                $height="32px"
                $heightSM="32px"
                $background={lightTheme.primary}
                $borderRadius="16px"
                $flex
                $alignCenter
                $p="0 24px"
                $mb="8"
                $between
              >
                <P $m="0" $color={lightTheme.white}>
                  {formatDateTimeShort(item.createdAt)}
                </P>
                <P
                  $m="0"
                  $color={lightTheme.white}
                  $underline
                  $pointer
                  onClick={() => setHistoryItemQuote(item)}
                >
                  View Quotes
                </P>
              </Div>

              {item.history.map((historyItem) => {
                return (
                  <Box $flex $alignCenter $gap="24px" $mb="8" $p="0 24px">
                    <Div $width="33%" $flex $alignCenter $gap="8px">
                      <Div $desktop>
                        <Img
                          alt=""
                          src={renderFleetImage(historyItem.provider ?? '')}
                          $width="30px"
                        />
                      </Div>
                      <P $m="0">
                        {renderFleetName(
                          historyItem.provider as VDriveProvider
                        )}
                      </P>
                    </Div>
                    <Div $width="33%">
                      <P $m="0">
                        {renderFleetSource(historyItem.source as VDriveSource)}
                      </P>
                    </Div>
                    <Div $width="33%">
                      <Pill
                        $gap="4px"
                        $background={
                          historyItem.status === 'success'
                            ? lightTheme.green
                            : lightTheme.primary
                        }
                      >
                        <Disclaimer
                          $m="0"
                          $color={lightTheme.white}
                          $capitalize
                          $semiBold
                        >
                          {historyItem.status === 'success'
                            ? 'Available'
                            : 'Error'}{' '}
                        </Disclaimer>
                        {renderQuoteHistoryError(historyItem.error) && (
                          <TooltipIcon
                            color={lightTheme.white}
                            tooltip={renderQuoteHistoryError(historyItem.error)}
                          />
                        )}
                      </Pill>
                    </Div>
                  </Box>
                );
              })}
            </>
          ))}
        {history && history.length === 0 && (
          <NoDataComponent
            height="200px"
            heightSM="200px"
            title="No Data"
            description="No assign history found"
          />
        )}
      </ModalPortal>
      <ModalPortal
        isOpen={!!historyItemQuote}
        closeModal={() => setHistoryItemQuote(null)}
        logo={false}
        header="Quotes"
        subtitle={`${formatDateTimeFull(historyItemQuote?.createdAt ?? '')}`}
        width="400px"
        textAlign="left"
        zIndex={131}
      >
        <Div>
          {historyItemQuote?.history.map((historyItemQuote, i) => {
            if (!historyItemQuote.quote) {
              return null;
            }
            return (
              <Div $relative>
                <QuoteOfferComponent
                  key={i}
                  offer={historyItemQuote?.quote as VDriveOffer}
                />
                {chosenVDriveProvider === historyItemQuote?.quote?.provider &&
                  chosenVDriveSource === historyItemQuote?.source && (
                    <Div $absolute $bottom="12px" $right="12px">
                      <Pill $background={lightTheme.primary} $gap="4px">
                        <Disclaimer $m="0" $bold $color={lightTheme.white}>
                          Chosen
                        </Disclaimer>
                      </Pill>
                    </Div>
                  )}
              </Div>
            );
          })}
          {historyItemQuote?.history.length === 0 && (
            <NoDataComponent
              height="200px"
              heightSM="200px"
              title="No Data"
              description="No assign history quotes found"
            />
          )}
        </Div>
      </ModalPortal>
    </>
  );
};
